/** True on Apple platforms, where the primary modifier is ⌘. */
export const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

/** The printed shortcut for "submit": ⌘↵ or Ctrl↵. */
export const submitKey = isMac ? '⌘↵' : 'Ctrl↵';
export const paletteKey = isMac ? '⌘K' : 'Ctrl K';

/** Whether a keyboard event comes from a field where typing is expected. */
export function isTyping(e: KeyboardEvent): boolean {
  const el = e.target as HTMLElement | null;
  return !!el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName));
}
